jQuery(function($)
{
    function handleOverlayClosed()
    {
        var $overlay = $(this);

        $overlay.find('video').each(function()
        {
            this.pause();
        });
    }

    function handleOverlayOpened()
    {
        var $overlay = $(this);

        $overlay.find('video').each(function()
        {
            this.play();
        });
    }

    $('video').each(function()
    {
        $(this).closest('.overlay')
            .on(orion.constants.EventOverlayClosed, handleOverlayClosed)
            .on(orion.constants.EventOverlayOpened, handleOverlayOpened);
    });
});
